import { DbgPaths } from "../../../../../utils/Paths"
import React, { FC } from "react"
import { FormattedMessage } from "react-intl"
import { Link, UnorderedListItem } from "@carrotfertility/carotene-core"
import { CategorySections } from "../PayingForCareModal"
import { reimbursementCategoryNameMessageKeys } from "#/components/views/reimbursements/reimbursementCategoryNameMessageKeys"

const AdoptionAndGCHeader = (): JSX.Element => {
  return (
    <p>
      <FormattedMessage defaultMessage="This category includes eligible expenses for the following journeys:" />
    </p>
  )
}

interface AdoptionGCListItemsProps {
  category: string
}

const AdoptionAndGCListItems: FC<AdoptionGCListItemsProps> = ({ category }): JSX.Element => {
  return (
    <>
      <UnorderedListItem>
        <FormattedMessage
          defaultMessage="<link>Adoption</link>"
          values={{
            link: (linkContent) => (
              <Link target="_blank" href={DbgPaths.ADOPTION_COVERAGE}>
                {linkContent}
              </Link>
            )
          }}
        />
      </UnorderedListItem>
      <UnorderedListItem>
        <FormattedMessage
          defaultMessage="<link>Gestational surrogacy</link>"
          values={{
            link: (linkContent) => (
              <Link target="_blank" href={DbgPaths.GESTATIONAL_SURROGACY_COVERAGE}>
                {linkContent}
              </Link>
            )
          }}
        />
      </UnorderedListItem>
      {category === reimbursementCategoryNameMessageKeys.FERTILITY_GC_ADOPTION && (
        <>
          <UnorderedListItem>
            <FormattedMessage
              defaultMessage="<link>Fertility care</link>"
              values={{
                link: (linkContent) => (
                  <Link target="_blank" href={DbgPaths.FERTILITY_COVERAGE}>
                    {linkContent}
                  </Link>
                )
              }}
            />
          </UnorderedListItem>
          <UnorderedListItem>
            <FormattedMessage
              defaultMessage="<link>Fertility preservation</link>"
              values={{
                link: (linkContent) => (
                  <Link target="_blank" href={DbgPaths.PRESERVATION_COVERAGE}>
                    {linkContent}
                  </Link>
                )
              }}
            />
          </UnorderedListItem>
        </>
      )}
    </>
  )
}

export function getAdoptionAndGCSections(category: string): CategorySections {
  return {
    header: <AdoptionAndGCHeader />,
    listItems: <AdoptionAndGCListItems category={category} />
  }
}
